import { Component, OnInit } from '@angular/core';
import { environment } from "src/environments/environment";
import { NavigationMenuService } from 'src/app/services';

@Component({
    selector: 'medpt-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  currentYear = new Date().getFullYear();
  cdnEndPoint = environment.cdnEndPoint;
  secureAppEndPoint = environment.SSO.secureAppUrl;
  constructor(
    
  ) {
    
  }

  ngOnInit(): void {
  }

}
